import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Minus } from 'lucide-react';
import { IMAGES, FAQS } from '../data/mock';

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <div className="bg-white">
      {/* Hero */}
      <section className="relative bg-[#0f1113] text-white overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-60"
          style={{ backgroundImage: `url(${IMAGES.faqOffice})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f1113] via-[#0f1113]/85 to-transparent" />
        <div className="relative max-w-[1280px] mx-auto px-6 py-24 md:py-28">
          <div className="max-w-xl">
            <p className="text-[11px] tracking-[0.3em] text-[#c9a961] mb-6 font-medium">FREQUENTLY ASKED</p>
            <h1 className="font-serif text-5xl md:text-6xl leading-[1.05] mb-6" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
              Answers. <br />Ahead of Time.
            </h1>
            <p className="text-white/80 text-base leading-relaxed max-w-md">
              Everything you need to know about how Aurelia delivers concierge care with clarity and confidence.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-[#f5f0ea] py-20 md:py-24">
        <div className="max-w-[900px] mx-auto px-6">
          <div className="text-center mb-12">
            <p className="text-[11px] tracking-[0.3em] text-[#c9a961] font-medium mb-5">YOUR QUESTIONS</p>
            <h2 className="font-serif text-4xl text-[#1c1e20] mb-3" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
              Clear answers, thoughtfully shared.
            </h2>
            <div className="w-16 h-[2px] bg-[#c9a961] mx-auto" />
          </div>

          <div className="space-y-3">
            {FAQS.map((item, i) => (
              <div key={item.q} className={`bg-white border transition-colors ${open === i ? 'border-[#c9a961]' : 'border-black/10'}`}>
                <button
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full text-left px-6 py-5 flex items-center justify-between gap-4"
                >
                  <span className="font-serif text-lg md:text-xl text-[#1c1e20]" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
                    {item.q}
                  </span>
                  <span className="w-8 h-8 rounded-full border border-[#c9a961] flex items-center justify-center text-[#c9a961] flex-shrink-0">
                    {open === i ? <Minus size={14} /> : <Plus size={14} />}
                  </span>
                </button>
                {open === i && (
                  <div className="px-6 pb-6 text-[#4a4a4a] leading-relaxed text-[15px] border-t border-black/5 pt-4">
                    {item.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="relative bg-[#141618] text-white">
        <div className="max-w-[1280px] mx-auto px-6 py-16 flex flex-col md:flex-row items-center justify-between gap-8">
          <div>
            <h3 className="font-serif text-3xl md:text-4xl leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
              Still have questions?
            </h3>
            <p className="text-white/70 mt-2">Our team is here to help you at any hour.</p>
          </div>
          <Link
            to="/contact"
            className="bg-[#c9a961] hover:bg-[#b89751] transition-colors duration-300 text-[#141618] tracking-[0.22em] text-[12px] font-semibold px-7 py-3.5"
          >
            GET IN TOUCH
          </Link>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
